var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTimesRound = function SvgTimesRound(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    fill: "none",
    viewBox: "0 0 22 22"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M11 0C4.871 0 0 4.871 0 11s4.871 11 11 11 11-4.871 11-11S17.129 0 11 0m4.243 16.5L11 12.257 6.757 16.5 5.5 15.243 9.743 11 5.5 6.757 6.757 5.5 11 9.743 15.243 5.5 16.5 6.757 12.257 11l4.243 4.243z"
  })));
};
export default SvgTimesRound;